import { fetchFromApi } from './';

const getCountries = () => fetchFromApi('/foreign-company/countries');

export default {
  getCountries,
};
